import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

/**
 * Requires an authenticated Django superuser. Any portal JWT is fine.
 */
const SuperuserRoute = ({ children }) => {
  const { user, loading, isAuthenticated } = useAuth();

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!user?.is_superuser) {
    const fallback = user?.active_role || user?.role || 'customer';
    return <Navigate to={`/${fallback}/dashboard`} replace />;
  }

  return children;
};

export default SuperuserRoute;
